import React from 'react'
import { HashLink as Link } from 'react-router-hash-link'

export default function UpArrow() {
  return (
    <Link to="#about-me" className='up-arrow'>↑</Link>
  )
}
